import React, { useState } from "react";
import { useCountry } from '../contexts/CountryContext';

const countryData = {
//   ALL: { label: "All Countries", flag: "https://cdn-icons-png.flaticon.com/512/44/44386.png" },
  SG: { label: "Singapore", flag: "https://flagcdn.com/w40/sg.png" },
  MY: { label: "Malaysia", flag: "https://flagcdn.com/w40/my.png" },
  ID: { label: "Indonesia", flag: "https://flagcdn.com/w40/id.png" },
  PH: { label: "Philippines", flag: "https://flagcdn.com/w40/ph.png" },
  VN: { label: "Vietnam", flag: "https://flagcdn.com/w40/vn.png" },
  TH: { label: "Thailand", flag: "https://flagcdn.com/w40/th.png" },
};

const CountryDropdown = ({ initialCountry = "MY", availableCountries }) => {
const { selectedCountry, updateCountry, countries, setAvailableCountries } = useCountry();


  const [open, setOpen] = useState(false);

  const countriesToShow = availableCountries || Object.keys(countryData);

  const handleSelect = (code) => {
    updateCountry(code); // update local state
    setOpen(false);
  };

  const styles = {
    container: { position: "relative", width: "180px", cursor: "pointer", fontFamily: "Arial, sans-serif" },
    selected: { display: "flex", alignItems: "center", justifyContent: "space-between", border: "1px solid #d1d5db", borderRadius: "8px", padding: "6px 10px", backgroundColor: "#fff" },
    flag: { width: "20px", height: "14px", marginRight: "8px" },
    list: { position: "absolute", top: "110%", left: 0, right: 0, border: "1px solid #d1d5db", borderRadius: "8px", backgroundColor: "#fff", maxHeight: "200px", overflowY: "auto", zIndex: 1000, padding: 0, margin: 0, listStyle: "none", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
    item: { display: "flex", alignItems: "center", padding: "6px 10px", transition: "background 0.2s" },
  };

  return (
    <div style={styles.container}>
      <div style={styles.selected} onClick={() => setOpen(!open)}>
        <img src={countryData[selectedCountry]?.flag} alt={countryData[selectedCountry]?.label} style={styles.flag} />
        <span>{countryData[selectedCountry]?.label}</span>
        <i className={`fas fa-chevron-${open ? "up" : "down"}`}></i>
      </div>

      {open && (
        <ul style={styles.list}>
          {countriesToShow.map((code) => (
            <li
              key={code}
              style={styles.item}
              onClick={() => handleSelect(code)}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f0f0")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
            >
              <img src={countryData[code].flag} alt={code} style={styles.flag} />
              <span>{countryData[code].label}</span>
            </li>
          ))}
        </ul>
      )}

    </div>
  );
};

export default CountryDropdown;
